import { type Image, type Media, type Video } from './types';
import { imagesMapper, videosMapper } from './utils';

interface Props {
	images: Image[];
	videos?: Video[] | null;
	contentVideos?: Video[] | null;
	showVideos?: boolean;
	styleExpValue?: boolean;
}

export const useCarouselMedia = ({
	images,
	videos,
	contentVideos,
	styleExpValue,
}: Props): Media[] => {
	if (!images || images.length === 0) return [];

	const [firstImage, ...restImages] = images;
	const [productVideo, ...restProductVideos] = videos ?? [];
	const [stylingVideo, ...restStylingVideos] = contentVideos ?? [];

	const hasProductVideo = !!productVideo;
	const hasStylingVideo = !!stylingVideo;
	const restProductMedia = videosMapper(restProductVideos, firstImage);
	const restStylingMedia = videosMapper(restStylingVideos, firstImage);
	const stylingMedia = hasStylingVideo
		? videosMapper([stylingVideo], firstImage)
		: [];
	const productMedia = hasProductVideo ? videosMapper([productVideo]) : [];

	//if both videos are available

	if (styleExpValue && hasProductVideo && hasStylingVideo) {
		return [
			...(firstImage ? imagesMapper([firstImage]) : []),
			...productMedia,
			...stylingMedia,
			...imagesMapper(restImages),
			...restProductMedia,
			...restStylingMedia,
		];
	}

	//if either product or styling video is available
	if (styleExpValue && (hasProductVideo || hasStylingVideo)) {
		const stitchedVideo = hasProductVideo ? productMedia : stylingMedia;
		const remainingProduct = hasProductVideo ? restProductMedia : [];
		const remainingStyling = hasStylingVideo ? restStylingMedia : [];

		return [
			...(firstImage ? imagesMapper([firstImage]) : []),
			...stitchedVideo,
			...imagesMapper(restImages),
			...remainingProduct,
			...remainingStyling,
		];
	}

	// CASE 3: Stitching not enabled – default order
	return [
		...(firstImage ? imagesMapper([firstImage]) : []),
		...(hasProductVideo ? productMedia : []),
		...imagesMapper(restImages),
		...restProductMedia,
		...(hasStylingVideo ? stylingMedia : []),
		...restStylingMedia,
	];
};
